module.exports = __webpack_public_path__ + "media/images/team/AnaCarolinaGois-ffec4675a3bc003cabad7cd6fc648f6f.png";